import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVnFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_52710)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M49.1383 41.3797H0.862596C0.386523 41.3797 0.000488281 40.9937 0.000488281 40.5176V9.4832C0.000488281 9.00713 0.386523 8.62109 0.862596 8.62109H49.1384C49.6145 8.62109 50.0005 9.00713 50.0005 9.4832V40.5176C50.0004 40.9938 49.6144 41.3797 49.1383 41.3797Z",
				fill: "#CD343C"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M25.4024 15.2313L27.708 22.1444L34.9952 22.2008C35.4026 22.2039 35.5715 22.724 35.2438 22.9661L29.3816 27.295L31.5798 34.243C31.7027 34.6315 31.2603 34.9529 30.9288 34.7159L25.0002 30.4783L19.0715 34.7159C18.74 34.9528 18.2977 34.6315 18.4205 34.243L20.6186 27.295L14.7565 22.9661C14.4286 22.7241 14.5977 22.2039 15.0051 22.2008L22.2923 22.1444L24.5978 15.2313C24.7268 14.8448 25.2735 14.8448 25.4024 15.2313Z",
				fill: "#FFE15A"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_52710",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgVnFlag);
export { ForwardRef as ReactComponent };
